import axios from 'axios'
import { API_URL } from './Cnx'

const REQUEST_URL = 'api/marcas'

export const insertMarcas = c => axios.post(`${API_URL}/${REQUEST_URL}/`, c)
export const getMarcas = q =>
  axios.get(`${API_URL}/${REQUEST_URL}/`, { params: q })
export const getMarca = id => axios.get(`${API_URL}/${REQUEST_URL}/${id}`)
export const updateMarcas = (id, c) =>
  axios.put(`${API_URL}/${REQUEST_URL}/${id}`, c)
export const deleteMarca = ids =>
  axios.delete(`${API_URL}/${REQUEST_URL}/`, { params: { ids } })
